import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import enCommon from './locales/en/common.json';
import enInspection from './locales/en/inspection.json';
import esCommon from './locales/es/common.json';
import esInspection from './locales/es/inspection.json';

export const supportedLanguages = ['en', 'es'] as const;
export type SupportedLanguage = (typeof supportedLanguages)[number];

const resources = {
  en: {
    common: enCommon,
    inspection: enInspection,
  },
  es: {
    common: esCommon,
    inspection: esInspection,
  },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    defaultNS: 'common',
    ns: ['common', 'inspection'],
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ['localStorage', 'navigator'],
      lookupLocalStorage: 'preferred_locale',
      caches: ['localStorage'],
    },
  });

export default i18n;
